import axios from '../axios';

//加载头文件
//import * as BaseMaterialStockApi from './moudules/base/BaseMaterialStockApi'; //物料仓库配置
//  BaseMaterialStockApi,//物料仓库配置

// 物料仓库配置列表
export const getBaseMaterialStockPage = data => {
return axios({
url: '/api/sys/base/getBaseMaterialStockPage',
method: 'post',
data
})
};

// 物料仓库配置保存
export const saveBaseMaterialStock = data => {
return axios({
url: '/api/sys/base/saveBaseMaterialStock',
method: 'post',
data
})
};

// 物料仓库配置修改
export const updateBaseMaterialStock = data => {
return axios({
url: '/api/sys/base/updateBaseMaterialStock',
method: 'post',
data
})
};

// 物料仓库配置删除
export const deleteBaseMaterialStocks = data => {
return axios({
url: '/api/sys/base/deleteBaseMaterialStocks',
method: 'post',
data
})
};

// 物料仓库配置查单条
export const getBaseMaterialStock = data => {
return axios({
url: '/api/sys/base/getBaseMaterialStock',
method: 'post',
data
})
};




// WEBPACK FOOTER //
// ./src/api/moudules/BaseMaterialStockApi.js